import React from 'react'
import { Outlet } from 'react-router-dom'

const Asset = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Asset
